import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import API from '../../../../api/api'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'
import { visitorDetailsType } from '../utils'

export const useVisitorDetails = (visitorType, visitorId) => {
  const { t } = useTranslation(['visitors'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [data, setData] = useState()

  const fetchData = async () => {
    try {
      setIsError(false)
      setIsLoading(true)
      const result =
        visitorType === visitorDetailsType.Guest
          ? await API.getGuestDetails(visitorId)
          : await API.getVendorDetails(visitorId)

      setData(result.data)
    } catch {
      displaySnackbar(t('visitors:snackbar.loadDetailsError'), true)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!visitorId) {
      return
    }
    fetchData()
  }, [visitorId])

  return { isLoading, isError, data }
}
